/*!
 * scramble-type init
 * Usage:
 *   ScrambleType.init(selector);
 *   ScrambleType.init(selector, { speed, pause, scrambleFrames, scrambleSpeed });
 */
document.addEventListener('DOMContentLoaded', function () {
  // Elements already authored with class="scramble-type" in the markup
  ScrambleType.init('.scramble-type');

  // Initiating Scramble Type Effect
  ScrambleType.init('.slideshow__slide-content .h1', {
    speed: 15,
    pause: 5000,
    align: 'center-mobile',
  });

  // Initiating Scramble Type Effect
  ScrambleType.init('.product-title.h3, .how-it-works .h3', {
    speed: 15,
    pause: 5000,
  });

  // Initiating Holographic Effect
  /*
  HolographicEffect.init('.product-gallery__media, .product-card__media', {
    opacityFill: 0.1,
    tiltMax: 12,
    tiltMaxGyro: 12
  });*/

});
